import React, { useEffect, useState } from "react";
import { fetchCourses } from "../services/api";
import CourseTable from "../components/CourseTable";
import { PartnerCourse } from "../types/course";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  AppBar,
  Toolbar,
} from "@mui/material";

const Home = () => {
  const [, setCourses] = useState<PartnerCourse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getCourses = async () => {
      try {
        const data = await fetchCourses();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    getCourses();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <AppBar position="static" sx={{ boxShadow: "none" }}>
        <Toolbar sx={{ justifyContent: "center" }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: "bold", flexGrow: 1, textAlign: "left" }}
          >
            🚀 SEP Finder
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md">
        <CourseTable />
        <Box textAlign="center" mt={4} mb={8}>
          <Typography variant="body2" color="textSecondary">
            Updated 2025 &copy;
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default Home;
